import dynamic from "next/dynamic";

// const LogosSlider = dynamic(() => import('../common/LogosSlider'))
import LogosSlider from "../common/LogosSlider";
import ServiceFullBanner from "./technology-full-banner/technology-banner";
import OptToHire from './opt-to-hire/opt-to-hire'

const FaqSection = dynamic(() => import('../home/faq/faq-section'))
const BookConsultant = dynamic(() => import('./technology-book-consultant/bookconsultant'))
const Frameworks = dynamic(() => import('./framework/framework'))
const OurMilestones = dynamic(() => import('./our-milestones-tabs/our-milestones-tabs'))
const OurMilestonesV2 = dynamic(() => import('./our-milestones-tabs/our-milestones-tabs-new'))
const HiringModels = dynamic(() => import('./hiring-models/hiring-models'))
const Strategies = dynamic(() => import('./strategies/strategies'))
const TechStack = dynamic(() => import('./tech-stack/tech-stack'))
const TechnologyFeature = dynamic(() => import('./technology-feature/technology-feature'))
const ScheduleInterview = dynamic(() => import('./schedule-interview/schedule-interview'))
const HireBestDevelopers = dynamic(() => import('./hire-best-developers/hire-best-developers'))
const TechnologyPageSlider = dynamic(() => import('./technologies-page-slider/technologies-page-slider'))

function Technology(props) {
	let blocks = props.blocks;

	return (
		<>
			{blocks.length > 0 && (
				<div className="middle-sction technologies-middle">
					{blocks.map((block, i) => {
						return (
							<div key={i}>
								{block.__component ===
									"blocks.service-banner" && (
									<>
										<ServiceFullBanner
											block={block}
											slug={props.slug}
											type={props.type}
											showTags={true}
										/>
										<LogosSlider />
									</>
								)}
								{block.__component === "blocks.opt-to-hire" && (
									<OptToHire block={block} />
								)}

								{block.__component ===
									"blocks.our-milestone-v2" && (
									<OurMilestonesV2 block={block} />
								)}
								{block.__component ===
									"blocks.hiring-models" && (
									<HiringModels block={block} />
								)}
								{block.__component ===
									"blocks.inquire-form" && (
									<ScheduleInterview
										block={block}
									/>
								)}
								{block.__component ===
									"blocks.our-milestones" &&
									!blocks?.find(
										(block) =>
											block.__component ===
											"blocks.our-milestone-v2"
									) && <OurMilestones block={block} />}
								{block.__component ===
									"blocks.technology-tech-stack" && (
									<TechStack block={block} />
								)}
								{block.__component ===
									"blocks.technology-page-tech-stack" && (
									<TechStack block={block} />
								)}
								{block.__component ===
									"blocks.technology-features" && (
									<TechnologyFeature block={block} />
								)}
								{block.__component === "blocks.strategies" && (
									<Strategies slug={props.pageSlug} block={block} />
								)}
								{block.__component ===
									"blocks.best-frameworks" && (
									<Frameworks block={block} />
								)}
								{block.__component ===
									"blocks.hire-best-developers" && (
									<HireBestDevelopers block={block} />
								)}
								{block.__component === "blocks.faq" && (
									<FaqSection block={block} />
								)}
								{block.__component ===
									"blocks.technologies-page-slider" && (
									<TechnologyPageSlider block={block} />
								)}
								{block.__component ===
									"blocks.book-consultations" && (
									<BookConsultant
										block={block}
									/>
								)}
							</div>
						);
					})}
				</div>
			)}
		</>
	);
}

export default Technology;
